import {
    ActionFunction,
    redirect
} from "react-router-dom";
import { axiosApi } from "../../../interceptors/axios";
import { toast } from "react-toastify";


export const resetPasswordAction: ActionFunction = async ({ request, params }) => {
    const formData = await request.formData();
    const updates = Object.fromEntries(formData);
    await toast.promise(axiosApi.post("/api/auth/reset-password", updates), { success: "Şifreniz güncellenmiştir", error: "Bir hata ile karşılaşıldı", pending: "Güncelleniyor..." });
    return redirect(`/`);
}